import {createAnnotation} from './utils/createAnnotation'

/**
 * The annotation builder for component tooltip properties.
 */
export const tooltipProps = createAnnotation('tooltipProps')
